import ValidatorManager from '../validators-manager'

class Field {
	constructor(el, form) {
		this._init(el, form)
	}
	_init(el, form) {
		this.el = el
		this.form = form
		if(!this.el) {
			return
		}
		const data = this.el.getAttribute('data-field')
		const dataSplit = data.split(' ')
		this.type = dataSplit[0]
		this.id = dataSplit[1]
		this.validators = new ValidatorManager(this.el)
		this.elError = this.el.querySelector('[data-field-error]')
		if(!this.elError) {
			return
		}
		this.errorMessage = this.elError.innerHTML
	}
	displayError(newError = null) {
		this.isDisplayingError = true
		this.setErrorMessage(newError)
		this.el.classList.add("field-is-invalid")
	}
	clearError() {
		this.isDisplayingError = false
		this.el.classList.remove("field-is-invalid")
	}
	setErrorMessage(newError) {
		if(newError) {
			this.elError.innerHTML = newError
		} else {
			this.elError.innerHTML = this.errorMessage
		}
	}
	validate() {
		return this.validators.validateAll()
	}
	getValue() {
		return this.validators.getValue()
	}
}

export default Field